<template>
  <FlashMessages />
  <RouterView />
  <AppFooter />
</template>

<script setup lang="ts">
import { RouterView } from "vue-router";
import FlashMessages from "@/components/common/FlashMessages.vue";
import AppFooter from "@/components/AppFooter.vue";
</script>
